// GSAP and ScrollTrigger are loaded via CDN in theme.liquid
// brazilMapSvg will be rendered via a Liquid snippet in the HTML
document.addEventListener('DOMContentLoaded', () => {
  /* ============================================
     MOBILE MENU LOGIC
  ============================================ */
  const navToggle = document.getElementById('nav-toggle');
  const navMenu = document.getElementById('nav-menu');
  const navLinks = document.querySelectorAll('.nav__link');

  if (navToggle && navMenu) {
    navToggle.addEventListener('click', () => {
      navToggle.classList.toggle('active');
      navMenu.classList.toggle('active');
      
      const isExpanded = navToggle.classList.contains('active');
      navToggle.setAttribute('aria-expanded', isExpanded);
    });
  }

  // Close menu when clicking a link
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      navToggle.classList.remove('active');
      navMenu.classList.remove('active');
      navToggle.setAttribute('aria-expanded', 'false');
    });
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (navMenu.classList.contains('active') && !navMenu.contains(e.target) && !navToggle.contains(e.target)) {
      navToggle.classList.remove('active');
      navMenu.classList.remove('active');
      navToggle.setAttribute('aria-expanded', 'false');
    }
  });

  /* ============================================
     HEADER BLUR ON SCROLL
  ============================================ */
  const header = document.getElementById('header');
  let isScrollingHeader = false;
  window.addEventListener('scroll', () => {
    if (!isScrollingHeader) {
      window.requestAnimationFrame(() => {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
        isScrollingHeader = false;
      });
      isScrollingHeader = true;
    }
  });

  /* ============================================
     HERO PARTICLES / GRID BG (Simple Canvas)
  ============================================ */
  const canvas = document.getElementById('particles-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let width, height;
    let particles = [];

    const initCanvas = () => {
      width = canvas.width = document.documentElement.clientWidth;
      height = canvas.height = document.documentElement.clientHeight;
      particles = [];
      
      const numParticles = document.documentElement.clientWidth < 768 ? 25 : 60; // Reduced for better performance
      
      for (let i = 0; i < numParticles; i++) {
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          size: Math.random() * 2 + 1
        });
      }
    };

      let animationFrameId;
      let isVisible = true;

      const drawParticles = () => {
        if (!isVisible) return; // Stop burning CPU when out of view

        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = 'rgba(245, 184, 0, 0.5)'; // Gold color
        
        particles.forEach(p => {
          p.x += p.vx;
          p.y += p.vy;
          
          if (p.x < 0) p.x = width;
          if (p.x > width) p.x = 0;
          if (p.y < 0) p.y = height;
          if (p.y > height) p.y = 0;
          
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fill();
        });
        
        // Draw lines between close particles
        ctx.strokeStyle = 'rgba(245, 184, 0, 0.1)';
        ctx.lineWidth = 1;
        
        for (let i = 0; i < particles.length; i++) {
          for (let j = i + 1; j < particles.length; j++) {
            const dx = particles[i].x - particles[j].x;
            const dy = particles[i].y - particles[j].y;
            // Use squared distance check for better performance
            const distSq = dx * dx + dy * dy;
            
            if (distSq < 8000) { // Slightly shorter lines to save render time
              ctx.beginPath();
              ctx.moveTo(particles[i].x, particles[i].y);
              ctx.lineTo(particles[j].x, particles[j].y);
              ctx.stroke();
            }
          }
        }
        
        animationFrameId = requestAnimationFrame(drawParticles);
      };

      initCanvas();
      
      isVisible = true;
      drawParticles();

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      const currentWidth = window.innerWidth;
      // Only reinitialize if the width changed (ignores mobile address bar vertical resizes)
      if (currentWidth !== lastWidth) {
        lastWidth = currentWidth;
        initCanvas();
      }
    });
  }

  /* ============================================
     TYPING EFFECT
  ============================================ */
  const typingElement = document.getElementById('typing-text');
  if (typingElement) {
    const words = ['Mineração', 'o Agronegócio', 'Sua Indústria'];
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let typeSpeed = 100;

    const type = () => {
      const currentWord = words[wordIndex];
      
      if (isDeleting) {
        typingElement.textContent = currentWord.substring(0, charIndex - 1);
        charIndex--;
        typeSpeed = 50;
      } else {
        typingElement.textContent = currentWord.substring(0, charIndex + 1);
        charIndex++;
        typeSpeed = 150;
      }

      if (!isDeleting && charIndex === currentWord.length) {
        isDeleting = true;
        typeSpeed = 2000; // Pause at end of word
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        typeSpeed = 500; // Pause before new word
      }

      setTimeout(type, typeSpeed);
    };

    setTimeout(type, 1000);
  }

  /* ============================================
     INTERACTIVE MAP CASES
  ============================================ */
  const mapContainer = document.getElementById('brazil-map-container');
  const infoContainer = document.getElementById('cases-info');
  
  if (mapContainer && infoContainer) {
    // SVG is rendered directly in the HTML by Shopify Liquid
    const casesData = {
      'pa': {
        badge: 'Mineração',
        badgeClass: 'case-card__badge--mining',
        number: '01',
        title: 'Britagem Primária Automatizada',
        location: '📍 Parauapebas, PA | Canaã dos Carajás, PA',
        desc: 'Automação completa de britagem primária com controle automático de descarga de caminhão via semáforo, monitoramento de nível na câmara de britagem e leitura de carga dos motores em tempo real.',
        results: [
          'Operação automática e padronizada',
          'Máquina na capacidade nominal do fabricante',
          'Otimização do consumo de energia',
          'Maior eficiência e produtividade'
        ]
      },
      'mg': {
        badge: 'Mineração',
        badgeClass: 'case-card__badge--mining',
        number: '02',
        title: 'Rebritagem Automatizada',
        location: '📍 Congonhas, MG | Itabira, MG',
        desc: 'Sensores estratégicos na câmara de britagem controlando alimentador vibratório e transportador de correia. Medição de eficiência por britador independente.',
        results: [
          'Operação sem dependência de operador',
          'Máxima capacidade de produção',
          'Maior vida útil do revestimento',
          'Leitura de carga e amperagem em tempo real'
        ]
      },
      'go': {
        badge: 'Mineração',
        badgeClass: 'case-card__badge--mining',
        number: '03',
        title: 'Moagem de Calcário',
        location: '📍 Catalão, GO | Nobres, MT',
        desc: 'Automação completa do moinho de calcário com controle total da alimentação e operação. Integração de dados em tempo real para decisões estratégicas.',
        results: [
          'Eficiência operacional consistente',
          'Redução de custos de energia',
          'Aumento de segurança no trabalho',
          'Sustentabilidade ambiental'
        ]
      },
      'mt': {
        badge: 'Mineração',
        badgeClass: 'case-card__badge--mining',
        number: '03',
        title: 'Moagem de Calcário',
        location: '📍 Catalão, GO | Nobres, MT',
        desc: 'Automação completa do moinho de calcário com controle total da alimentação e operação. Integração de dados em tempo real para decisões estratégicas.',
        results: [
          'Eficiência operacional consistente',
          'Redução de custos de energia',
          'Aumento de segurança no trabalho',
          'Sustentabilidade ambiental'
        ]
      },
      'ba': {
        badge: 'Agronegócio',
        badgeClass: 'case-card__badge--agro',
        number: '04',
        title: 'Fábrica de Ração 4.0',
        location: '📍 Rio Verde, GO | Rondonópolis, MT | Luís Eduardo Magalhães, BA',
        desc: 'Sistema completo de automação para dosagem e operação remota da fábrica de ração. Supervisório com geração de receitas, relatórios de produção e alarmes.',
        results: [
          'Controle preciso de dosagem',
          'Rastreabilidade total de lotes',
          'Redução de desperdícios',
          'Operação totalmente remota'
        ]
      }
    };
    
    const paths = mapContainer.querySelectorAll('path');
    let activePath = null;
    let autoPlayInterval = null;
    
    paths.forEach(path => {
      const stateId = (path.id || '').toLowerCase();
      
      if (casesData[stateId]) {
        path.classList.add('has-case');
      }
      
      // On desktop, add hover/click interactions
      if (window.innerWidth >= 992) {
        path.addEventListener('mouseenter', () => {
          clearInterval(autoPlayInterval);
          handleStateSelect(path, stateId);
        });
        path.addEventListener('click', () => {
          clearInterval(autoPlayInterval);
          handleStateSelect(path, stateId);
        });
      }
    });

    // Mobile Auto-play logic (Carousel)
    if (window.innerWidth < 992) {
      // Get unique case states
      const caseStates = Object.keys(casesData);
      let currentIndex = 0;
      
      const playNext = () => {
        const stateId = caseStates[currentIndex];
        // Try uppercase ID first, then fallback
        const path = document.getElementById(stateId.toUpperCase()) || document.getElementById(stateId);
        if (path) {
          handleStateSelect(path, stateId);
        }
        currentIndex = (currentIndex + 1) % caseStates.length;
      };
      
      // Start immediately to replace the "click/hover" text
      playNext();
      // Loop every 4.5 seconds
      autoPlayInterval = setInterval(playNext, 4500);
    }
    
    function handleStateSelect(path, stateId) {
      if (activePath) activePath.classList.remove('active');
      activePath = path;
      path.classList.add('active');
      
      const caseInfo = casesData[stateId];
      
      if (caseInfo) {
        let resultsHtml = '';
        caseInfo.results.forEach(res => {
          resultsHtml += `<li><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--c-accent)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> ${res}</li>`;
        });

        infoContainer.innerHTML = `
          <div class="case-card">
            <div class="case-card__header">
              <span class="case-card__badge ${caseInfo.badgeClass}">${caseInfo.badge}</span>
              <span class="case-card__number">${caseInfo.number}</span>
            </div>
            <h3 class="case-card__title">${caseInfo.title}</h3>
            <p class="case-card__location">${caseInfo.location}</p>
            <p class="case-card__desc">${caseInfo.desc}</p>
            <div class="case-card__results">
              <h4>Resultados</h4>
              <ul>${resultsHtml}</ul>
            </div>
          </div>
        `;
      } else {
        infoContainer.innerHTML = `
          <div class="cases__empty">
            <div class="cases__empty-icon">📍</div>
            <p>Ainda não temos um case publicado para este estado, mas a ZABE atua em todo o território nacional. <a href="#contact" style="color:var(--c-accent); text-decoration:underline;">Fale conosco</a>!</p>
          </div>
        `;
      }
    }
  }

  /* ============================================
     GSAP ANIMATIONS
  ============================================ */
  


  // Hero elements stagger in
  if (document.querySelector('.hero__title')) {
    const heroTl = gsap.timeline({
      defaults: { ease: 'power3.out' }
    });

    heroTl.from('.hero__title', { y: 30, opacity: 0, duration: 0.8, ease: 'power3.out' })
          .from('.hero__subtitle', { y: 20, opacity: 0, duration: 0.6, ease: 'power3.out' }, '-=0.4')
          .from('.hero__description', { y: 20, opacity: 0, duration: 0.6, ease: 'power3.out' }, '-=0.4')
          .from('.hero__actions .btn', { y: 20, opacity: 0, duration: 0.6, stagger: 0.2, ease: 'power3.out' }, '-=0.4')
          .from('.hero__scroll-indicator', { opacity: 0, duration: 1 }, '-=0.2');
  }

  // Stats Counters
  const statCards = document.querySelectorAll('.stat-card');
  if (statCards.length > 0) {
    ScrollTrigger.create({
      trigger: '.stats',
      start: 'top 80%',
      onEnter: () => {
        statCards.forEach(card => {
          const target = parseInt(card.getAttribute('data-count'));
          const numberEl = card.querySelector('.stat-card__number');
          
          gsap.to(numberEl, {
            innerHTML: target,
            duration: 2,
            snap: { innerHTML: 1 },
            ease: 'power2.out'
          });
        });
      },
      once: true
    });
  }

  // Fade up sections
  const sections = ['.about', '.solutions', '.sectors', '.cases', '.connect', '.contact'];
  sections.forEach(sec => {
    const target = document.querySelector(`${sec} .section-header`);
    if (target) {
      gsap.from(target, {
        scrollTrigger: {
          trigger: sec,
          start: 'top 80%',
        },
        y: 30,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out'
      });
    }
  });

  // Stagger About Pillars
  gsap.utils.toArray('.pillar-card').forEach((card, i) => {
    gsap.fromTo(card, 
      { opacity: 0, y: 30 },
      {
        scrollTrigger: {
          trigger: card,
          start: 'top 90%',
        },
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        delay: (i % 4) * 0.15
      }
    );
  });

  // Stagger Solutions
  gsap.utils.toArray('.solution-card').forEach((card, i) => {
    gsap.fromTo(card, 
      { opacity: 0, y: 40 },
      {
        scrollTrigger: {
          trigger: card,
          start: 'top 90%',
        },
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power3.out',
        delay: (i % 4) * 0.1
      }
    );
  });

  // Connect Mockup Parallax
  const connectMockupEl = document.querySelector('.connect__mockup');
  if (connectMockupEl) {
    gsap.to(connectMockupEl, {
      scrollTrigger: {
        trigger: '.connect',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      },
      y: -50,
      ease: 'none'
    });
  }

  // Sectors infinite loop is handled via CSS marquee animation

  /* ============================================
     DYNAMIC AMBIENT EFFECTS
  ============================================ */

  // Magnetic Buttons
  const magneticBtns = document.querySelectorAll('.btn--primary');
  if (window.matchMedia("(hover: hover)").matches) {
    magneticBtns.forEach(btn => {
      let rect;
      
      btn.addEventListener('mouseenter', () => {
        rect = btn.getBoundingClientRect();
      });
      
      btn.addEventListener('mousemove', (e) => {
        if (!rect) rect = btn.getBoundingClientRect(); // fallback
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        gsap.to(btn, {
          x: x * 0.3,
          y: y * 0.3,
          duration: 0.4,
          ease: 'power2.out'
        });
      });
      
      btn.addEventListener('mouseleave', () => {
        gsap.to(btn, {
          x: 0,
          y: 0,
          duration: 0.7,
          ease: 'elastic.out(1, 0.3)'
        });
      });
    });
  }

  // 3D Tilt for Mockup
  const connectVisual = document.querySelector('.connect__visual');
  const connectMockup = document.querySelector('.connect__mockup');
  
  if (connectVisual && connectMockup && window.matchMedia("(hover: hover)").matches) {
    let connectRect;
    
    connectVisual.addEventListener('mouseenter', () => {
      connectRect = connectVisual.getBoundingClientRect();
    });
    
    connectVisual.addEventListener('mousemove', (e) => {
      if (!connectRect) connectRect = connectVisual.getBoundingClientRect();
      const x = e.clientX - connectRect.left;
      const y = e.clientY - connectRect.top;
      
      const centerX = connectRect.width / 2;
      const centerY = connectRect.height / 2;
      
      const tiltX = ((y - centerY) / centerY) * -15; // max 15 deg
      const tiltY = ((x - centerX) / centerX) * 15;
      
      gsap.to(connectMockup, {
        rotateX: tiltX,
        rotateY: tiltY,
        duration: 0.5,
        ease: 'power2.out',
        transformPerspective: 1000
      });
    });
    
    connectVisual.addEventListener('mouseleave', () => {
      gsap.to(connectMockup, {
        rotateX: 0,
        rotateY: 0,
        duration: 1,
        ease: 'elastic.out(1, 0.3)'
      });
    });
  }

  /* ============================================
     MODAL & IBGE API LOGIC
  ============================================ */
  const modal = document.getElementById('contactModal');
  const modalOpenBtns = document.querySelectorAll('[data-modal-target]');
  const modalCloseBtns = document.querySelectorAll('[data-modal-close]');
  const stateSelect = document.getElementById('modal-state');
  const citySelect = document.getElementById('modal-city');
  const contactForm = document.getElementById('modal-contact-form');
  const phoneInput = document.getElementById('modal-phone');
  const cnpjInput = document.getElementById('modal-cnpj');

  if (modal) {
    // Open Modal
    modalOpenBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      });
    });

    // Close Modal
    modalCloseBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Handle State change to load Cities
    if (stateSelect) {
      let cachedCities = null;

      stateSelect.addEventListener('change', (e) => {
        const uf = e.target.value;
        citySelect.innerHTML = '<option value="" disabled selected>Carregando cidades...</option>';
        citySelect.disabled = true;

        if (uf) {
          if (cachedCities) {
            populateCities(cachedCities, uf);
          } else {
            fetch(`/cidades.json`)
              .then(res => res.json())
              .then(data => {
                cachedCities = data;
                populateCities(data, uf);
              })
              .catch(err => {
                console.error('Erro ao carregar cidades', err);
                citySelect.innerHTML = '<option value="" disabled selected>Erro ao carregar</option>';
              });
          }
        }
      });

      function populateCities(data, uf) {
        const cities = data[uf] || [];
        citySelect.innerHTML = '<option value="" disabled selected>Selecione a Cidade</option>';
        cities.forEach(cityName => {
          const option = document.createElement('option');
          option.value = cityName;
          option.textContent = cityName;
          citySelect.appendChild(option);
        });
        citySelect.disabled = false;
      }
    }

    // Input Masks
    const maskPhone = (value) => {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d{4})\d+?$/, '$1-$2');
    };

    const maskCNPJ = (value) => {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    };

    if (phoneInput) {
      phoneInput.addEventListener('input', (e) => {
        e.target.value = maskPhone(e.target.value);
      });
    }

    if (cnpjInput) {
      cnpjInput.addEventListener('input', (e) => {
        e.target.value = maskCNPJ(e.target.value);
      });
    }

    // Form Submit -> WhatsApp
    if (contactForm) {
      contactForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const name = document.getElementById('modal-name').value;
        const email = document.getElementById('modal-email').value;
        const phone = document.getElementById('modal-phone').value;
        const cnpj = document.getElementById('modal-cnpj').value;
        const state = document.getElementById('modal-state').value || '';
        const city = document.getElementById('modal-city').value || '';

        let message = `Olá ZABE, me chamo ${name}, meu e-mail é ${email}`;
        if (phone) message += `, meu WhatsApp é ${phone}`;
        if (cnpj) message += `, represento o CNPJ ${cnpj}`;
        if (city && state) message += `, de ${city} - ${state}`;
        else if (state) message += `, de ${state}`;
        else if (city) message += `, de ${city}`;
        message += `. Gostaria de falar com um especialista!`;

        const whatsappNumber = '5562996912332';
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        window.open(whatsappUrl, '_blank');
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        contactForm.reset();
        if (citySelect) {
          citySelect.innerHTML = '<option value="" disabled selected>Cidade</option>';
          citySelect.disabled = true;
        }
      });
    }
  }

});
